import { useEffect } from 'react';
import { Navigate } from '@leagueplatform/routing';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import {
  ANALYTICS_SCREEN_NAMES,
  PRODUCT_AREAS,
  SUB_PRODUCT_AREAS,
} from 'common/constants';

export const CareManagementFlowRedirect = () => {
  useEffect(() => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREAS.BENEFITS,
      sub_product_area: SUB_PRODUCT_AREAS.ADDITIONAL_BENEFITS,
      screen_name: ANALYTICS_SCREEN_NAMES.HEALTH_JOURNEY_ACTIVITIES,
      detail: 'navigate to additional benefit detail page',
      league_system: 'toolbox',
    });
  }, []);
  return <Navigate to={APP_MANAGED_ROUTES.CASE_MANAGEMENT_PROGRAM} replace />;
};
